import React from "react";
import { connect } from "react-redux";
import { BaseComponent } from "BaseComponent";
import _ from "lodash";
import Swatch from "Swatch";
import { SketchPicker } from "react-color";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import { selectSwatch, updateThemeColors } from "BrandingAction";
import { updateUnsavedChanges } from "DashboardMenuAction";
import { IMAGE_PATH, BASE_IMAGES_URL } from "Constants";
import LocaleStrings from "Languages";

class ColorTheme extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedColor: "",
      pickerVisible: false,
    };

    this.onColorChange = this.onColorChange.bind(this);
  }

  renderSwatches() {
    const { colors } = this.props;

    return colors.map((colordata, id) => {
      return (
        <Swatch
          key={id}
          data={colordata}
          colors={colors}
          onCustomColorSelection={this.customColorSelection}
          onColorChange={this.onColorChange}
        />
      );
    });
  }

  onColorChange(newarr, newValue) {
    this.props.updateThemeColors(newarr);
    this.props.selectSwatch(newValue);
  }

  customColorSelection = () => {
    this.openColorPicker();
  };

  handleColorChange = ({ hex }) => {
    this.props.updateUnsavedChanges();
    var newValue = { ...this.props.activeColor, color: hex, selected: true };
    this.props.selectSwatch(newValue);
    var curarr = [...this.props.colors];
    curarr = curarr.splice(0, curarr.length - 1);
    curarr.push(newValue);
    this.props.updateThemeColors(curarr);
    this.setState({ selectedColor: _.toUpper(hex) });
  };

  closePicker = () => {
    this.setState({ pickerVisible: false });
  };

  openColorPicker = () => {
    if (!this.state.pickerVisible) {
      document.addEventListener("click", this.handleOutsideClick, false);
    } else {
      document.removeEventListener("click", this.handleOutsideClick, false);
    }

    this.setState((prevState) => ({
      pickerVisible: !prevState.pickerVisible,
    }));
  };

  handleOutsideClick = (e) => {
    // Needed dont delete if (!this.node.contains(e.target)) this.openColorPicker();
  };

  inputChangedHandler(event) {
    const value = event.target.value;
    this.setState({ selectedColor: value });
  }

  render() {
    var { selectedColor, pickerVisible } = this.state;
    var { activeColor, pickedColor, imageIcon, imageCover } = this.props;

    var styleHidden = { display: "none" };
    if (activeColor.custom && activeColor.selected) {
      styleHidden = { display: "block" };
    }

    var { eventicon, eventcover } = this.props.brandingData;
    var eventIconPreviewUrl = "";
    var eventCoverPreviewUrl = "";

    if (imageIcon) {
      eventIconPreviewUrl = imageIcon;
    } else if (eventicon) {
      eventIconPreviewUrl = `${BASE_IMAGES_URL}/${eventicon}?api_key=${this.props.session.apiKey}&session_token=${this.props.session.sessionToken}`;
    } else {
      eventIconPreviewUrl =
        "../../style/images/v2_icons/branding/branding_icon_placeholder.png";
    }

    if (imageCover) {
      eventCoverPreviewUrl = imageCover;
    } else if (eventcover) {
      eventCoverPreviewUrl = `${BASE_IMAGES_URL}/${eventcover}?api_key=${this.props.session.apiKey}&session_token=${this.props.session.sessionToken}`;
    }

    return (
      <div className="form-group">
        <div className="vertical-align-center gap-3">
          <label className="control-label-top container-largerscreen">
            {LocaleStrings.branding_color_theme}
          </label>

          <OverlayTrigger
            key={`event-theme-color`}
            placement="right"
            overlay={
              <Tooltip id={`event-theme-color`}>
                <div className="custom-text1-white-normal">
                  {LocaleStrings.branding_color_theme_info}
                </div>
              </Tooltip>
            }
          >
            <img
              src={`${IMAGE_PATH}header-icons/infoicon.png`}
              className="pointer"
              alt="info icon"
            />
          </OverlayTrigger>
        </div>

        <div className="custom-text2-secondary-medium">
          {LocaleStrings.branding_color_theme_subtitle1}
        </div>

        <div className="swatchContainer">{this.renderSwatches()}</div>
        <div
          style={{ position: "relative" }}
          ref={(node) => {
            this.node = node;
          }}
        >
          {this.state.pickerVisible && (
            <div className="picker-container">
              <img
                className="picker-close-button"
                src="../../style/images/v2_icons/circle_cross_solid.png"
                onClick={this.openColorPicker}
              />
              <SketchPicker
                color={selectedColor}
                onChangeComplete={this.handleColorChange}
              />
            </div>
          )}
        </div>
        <div
          className="branding-template-container"
          style={{ background: pickedColor.color }}
        >
          <div className="branding-cover-container">
            {eventCoverPreviewUrl ? <img src={eventCoverPreviewUrl} /> : null}
          </div>
          <img src="../../style/images/v2_icons/branding/branding_placeholder_image.png" />
          <div className="branding-icon-container">
            <img src={eventIconPreviewUrl} />
          </div>
          <div className="branding-container-header">
            <img src="../../style/images/v2_icons/branding/branding_placeholder_header.png" />
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  var selectedColor = state.themeColors.filter(
    (color) => color.selected === true
  );
  if (selectedColor.length > 0) {
    selectedColor = selectedColor[0];
  }

  var activeColor = {};
  if (state.brandingColor.color) {
    activeColor = state.brandingColor.color;
  }
  return {
    brandingData: state.brandingData,
    session: state.session,
    activeColor,
    colors: state.themeColors,
    pickedColor: selectedColor,
    imageCover: state.localImageCover,
    imageIcon: state.localImageIcon,
    unsavedChanges: state.unsavedChanges,
  };
}

export default connect(
  mapStateToProps,
  { selectSwatch, updateThemeColors, updateUnsavedChanges },
  null,
  { forwardRef: true }
)(ColorTheme);
